import { render, staticRenderFns } from "./AssignToClass.vue?vue&type=template&id=102f811c&scoped=true&"
import script from "./AssignToClass.vue?vue&type=script&lang=js&"
export * from "./AssignToClass.vue?vue&type=script&lang=js&"
import style0 from "./AssignToClass.vue?vue&type=style&index=0&id=102f811c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "102f811c",
  null
  
)

export default component.exports